import { BrowserModule } from '@angular/platform-browser';
import { NgModule,APP_INITIALIZER ,DoBootstrap} from '@angular/core';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import {FormsModule} from '@angular/forms';
import { HttpClientModule } from '@angular/common/http'; 
import { AppComponent } from './app.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {DropdownModule} from 'primeng/dropdown';
import {BrowserAnimationsModule} from "@angular/platform-browser/animations"
import {RatingModule} from 'primeng/rating';
import {InputTextModule} from 'primeng/inputtext';
import {SelectButtonModule} from 'primeng/selectbutton';
import { environment } from '../environments/environment';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import {CheckboxModule} from 'primeng/checkbox';
import {InputSwitchModule} from 'primeng/inputswitch';
import {CalendarModule} from 'primeng/calendar';
//let keycloakService: KeycloakService = new KeycloakService();
import { AppRoutingModule } from './app-routing.module';
import { SentTrayComponent } from './sent-tray/sent-tray.component';
import {TableModule} from 'primeng/table';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {TabMenuModule} from 'primeng/tabmenu';
import {RadioButtonModule} from 'primeng/radiobutton';
import {SidebarModule} from 'primeng/sidebar';
import {ToastModule} from 'primeng/toast';
import { UploadComponent } from './upload/upload.component';
import {MessageService} from 'primeng/api';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {DialogModule} from 'primeng/dialog';
import {EditComponent} from './edit/edit.component'
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MainInterceptorInterceptor } from './interceptors/main-interceptor.interceptor';
import { MessagesModule} from 'primeng/messages';


function initializeKeycloak(keycloak: KeycloakService) {
  return () =>
    keycloak.init({
      config: {
        url: environment.KC_URL,
        realm: environment.KC_REALM,
        clientId: environment.KC_CLIENT_ID,
      },
      initOptions: {
      },
    });
}




@NgModule({
  declarations: [
    AppComponent,
    SentTrayComponent,
    UploadComponent,
    EditComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FontAwesomeModule,
    FormsModule,
    NgbModule,
    DropdownModule,
    RatingModule,
    InputTextModule,
    SelectButtonModule,
    KeycloakAngularModule,
    AppRoutingModule,
    NgxQRCodeModule,
    InputSwitchModule,
    TableModule,
    CheckboxModule,
    CalendarModule,
    TabMenuModule,
    AutoCompleteModule,
    RadioButtonModule,
    SidebarModule,
    ToastModule,
    ProgressSpinnerModule,
    DialogModule,
    MessagesModule,
    
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService],
    },MessageService,
      { 
      provide: HTTP_INTERCEPTORS, useClass: MainInterceptorInterceptor, multi:true
    },
  ],
  entryComponents: [AppComponent],
  bootstrap: [AppComponent]
})


export class AppModule {}
